import * as React from "react";
import { styled } from "@mui/material";
import {
  ActionButton,
  ActionButtonProps,
} from "fe-common/ui/buttons/actionButton";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

export interface ColoredRoundActionButtonProps extends ActionButtonProps {
  kahunColor?: KahunColorMap;
}

//region [[ Styles ]]
/***
 * A common action green button
 * TODO: add an extention to show preview in documnetation window
 * @see ./preview/coloredRoundActionButtonPreview.png
 */
export const ColoredRoundActionButton = styled(
  ({ ...props }: ActionButtonProps) => (
    <ActionButton {...props} primary={"true"} />
  ),
)({
  borderRadius: "18px",
  fontSize: "17px",
  fontWeight: 500,
  minWidth: "106px",
  backgroundColor: ({ kahunColor }: ColoredRoundActionButtonProps) =>
    kahunColor ? kahunColor : KahunColorMap.Secondary,
  "&:hover": {
    backgroundColor: ({ kahunColor }: ColoredRoundActionButtonProps) =>
      kahunColor ? kahunColor : KahunColorMap.Secondary,
  },
});
